(() => {
  const LOTTIE_SCRIPT_ID = 'lottie-web-player-script';
  const LOTTIE_SCRIPT_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/bodymovin/5.12.2/lottie.min.js';

  function loadLottieScript() {
    return new Promise((resolve, reject) => {
      if (window.lottie) {
        resolve(window.lottie);
        return;
      }

      const existing = document.getElementById(LOTTIE_SCRIPT_ID);
      if (existing) {
        existing.addEventListener('load', () => resolve(window.lottie));
        existing.addEventListener('error', reject);
        return;
      }

      const script = document.createElement('script');
      script.id = LOTTIE_SCRIPT_ID;
      script.src = LOTTIE_SCRIPT_SRC;
      script.async = true;
      script.onload = () => resolve(window.lottie);
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function isMobileViewport() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getBoolean(value) {
    return String(value) === 'true';
  }

  function initIntro(section) {
    if (!section) return;
    if (section.dataset.initialised === 'true') return;

    section.dataset.initialised = 'true';

    const sectionId = section.dataset.sectionId;
    const lottieUrl = section.dataset.lottieUrl;
    const playOnce = getBoolean(section.dataset.playOnce);
    const showSkip = getBoolean(section.dataset.showSkip);
    const enableMobile = getBoolean(section.dataset.enableMobile);
    const timeout = parseInt(section.dataset.timeout || '2200', 10);
    const delay = parseInt(section.dataset.delay || '0', 10);
    const fadeDuration = parseInt(section.dataset.fadeDuration || '500', 10);
    const sessionKey = `homepage-lottie-intro-played-${sectionId}`;
    const player = document.getElementById(`HomepageLottiePlayer-${sectionId}`);
    const skipButton = section.querySelector('[data-intro-skip]');

    if (!player) {
      section.remove();
      return;
    }

    if (prefersReducedMotion()) {
      section.remove();
      return;
    }

    if (isMobileViewport() && !enableMobile) {
      section.remove();
      return;
    }

    if (!lottieUrl || lottieUrl.trim() === '') {
      section.remove();
      return;
    }

    if (playOnce && sessionStorage.getItem(sessionKey) === '1') {
      section.remove();
      return;
    }

    let animationInstance = null;
    let closed = false;
    let timeoutHandle = null;

    // function closeIntro() {
    //   if (closed) return;
    //   closed = true;

    //   if (animationInstance) {
    //     try {
    //       animationInstance.destroy();
    //     } catch (error) {
    //       // no-op
    //     }
    //   }

    //   section.classList.add('is-hidden');
    //   document.body.classList.remove('homepage-lottie-intro-lock');

    //   if (playOnce) {
    //     sessionStorage.setItem(sessionKey, '1');
    //   }

    //   window.setTimeout(() => {
    //     section.remove();
    //   }, fadeDuration);
    // }


    function closeIntro() {
      if (closed) return;
      closed = true;

      const overlay = section.querySelector('.homepage-lottie-intro__overlay');

      document.body.classList.remove('homepage-lottie-intro-lock');

      if (overlay) {
        // Force layout for browser to register current state
        overlay.getBoundingClientRect();

        // Trigger fade by adding a class
        section.classList.add('fade-out');
      }

      if (playOnce) {
        sessionStorage.setItem(sessionKey, '1');
      }

      // Destroy Lottie after a short delay so it doesn’t interfere
      setTimeout(() => {
        if (animationInstance) {
          try {
            animationInstance.destroy();
          } catch (error) {}
        }
      }, 50);

      // Remove overlay completely after fade duration
      setTimeout(() => {
        section.remove();
      }, fadeDuration);
    }


    function bindSkip() {
      if (!showSkip || !skipButton) return;
      skipButton.addEventListener('click', closeIntro);
    }

    function startPlayback() {
      document.body.classList.add('homepage-lottie-intro-lock');
      bindSkip();

      loadLottieScript()
        .then((lottie) => {
          if (!lottie) {
            closeIntro();
            return;
          }

          animationInstance = lottie.loadAnimation({
            container: player,
            renderer: 'svg',
            loop: false,
            autoplay: true,
            path: lottieUrl,
            rendererSettings: {
              progressiveLoad: true,
              preserveAspectRatio: 'xMidYMid meet'
            }
          });

          animationInstance.addEventListener('complete', closeIntro);

          timeoutHandle = window.setTimeout(() => {
            closeIntro();
          }, timeout);
        })
        .catch(() => {
          closeIntro();
        });
    }

    window.setTimeout(startPlayback, delay);

    window.addEventListener('pagehide', () => {
      if (timeoutHandle) {
        clearTimeout(timeoutHandle);
      }
      if (animationInstance) {
        try {
          animationInstance.destroy();
        } catch (error) {
          // no-op
        }
      }
    });
  }

  function initAll() {
    const sections = document.querySelectorAll('[id^="HomepageLottieIntro-"]');
    sections.forEach(initIntro);
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[id^="HomepageLottieIntro-"]') || event.target;
    if (section && section.id && section.id.startsWith('HomepageLottieIntro-')) {
      initIntro(section);
    }
  });
})();
